module.exports = __webpack_public_path__ + "img/dataFeature.40e67095.png";